export default __webpack_public_path__ + "static/media/placeholder_small.4edf9d9c.svg";